// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__RnP3C","image":"Header_image__24r2L","name":"Header_name__r2wqq","info":"Header_info__6sIp9","infoRow":"Header_infoRow__2h53T"};